// noinspection GraphQLUnresolvedReference

import { gql } from "graphql-request";

export const GetScenarioProjectByID = gql`
    mutation ExecuteGetScenarioProjectList (
        $inScenarioID: UUID!
        $inEdited: Int
    ){
        executeGetScenarioProjectList(
            inScenarioID: $inScenarioID
            inEdited: $inEdited
        ) {
            ScenarioID
            SourceID
            ScenarioProjID
            ProjID
            ProjectName
            State
            Source
            Investment
            RawProjectType
            ProjectStage
            StartDateConstruction
            EndDateConstruction
            FundingMode
            LocationID
            PeriodStartYear
            PeriodEndYear
            km
            MW
            M2
            RemoveProjectFromModel
            EditedProject
            ReadonlyProject
            ProcessingPath
        }
    }
`;
export const UpsertScenarioProject = gql`
    mutation ExecuteUpsertScenarioProject (
        $inScenarioID: UUID!
        $inScenarioProjID: Int!
        $inRemoveProjectFromModel: Int!
        $inEditedProject: Int!
        $inProjID: Int
        $inSourceID: String
        $inProjectName: String!
        $inLocationID: String!
        $inState: String!
        $inSource: String!
        $inInvestment: String!
        $inRawProjectType: String!
        $inProjectStage: String
        $inStartDateConstruction: DateTime!
        $inEndDateConstruction: DateTime!
        $inFundingMode: String
        $inStartYear: Int
        $inEndYear: Int
        $inKM: String
        $inMW: String
        $inM2: String
        $inProcessingPath: Int
    ) {
        executeUpsertScenarioProject(
            inSourceID: $inSourceID
            inScenarioID: $inScenarioID
            inRemoveProjectFromModel: $inRemoveProjectFromModel
            inEditedProject: $inEditedProject
            inScenarioProjID: $inScenarioProjID
            inProjID: $inProjID
            inProjectName: $inProjectName
            inLocationID: $inLocationID
            inState: $inState
            inSource: $inSource
            inInvestment: $inInvestment
            inRawProjectType: $inRawProjectType
            inProjectStage: $inProjectStage
            inStartDateConstruction: $inStartDateConstruction
            inEndDateConstruction: $inEndDateConstruction
            inFundingMode: $inFundingMode
            inStartYear: $inStartYear
            inEndYear: $inEndYear
            inKM: $inKM
            inMW: $inMW
            inM2: $inM2
            inProcessingPath: $inProcessingPath
        ) {
            ScenarioProjID
        }
    }

`;

// GetLastUploadedProjectList
export const GetLastUploadedProjectList = gql`
    mutation ExecuteGetLastUploadedProjectList(
        $inJurisdiction: String!,
        $inScenarioID: String
    ) {
        executeGetLastUploadedProjectList(
             inJurisdiction: $inJurisdiction
        ) {
            Source
            ProjectID
            ProjectName
            State
            typeCast
            Investment
            MW
            KM
            M2
            ProjectStage
            DeliveryAgency
            ContractingModel
            StartDateConstruction
            EndDateConstruction
            project_location
            Latitude
            Longitude
            FundingMode
            sa4_code
            sa4_name
            CommonwealthFunding
            ProjectStatus
            PeriodStartYear
            PeriodEndYear
        }
        executeGetState(inJurisdiction: $inJurisdiction) {
            State
        }
        executeGetSourceList(inJurisdiction: $inJurisdiction, inScenarioID: $inScenarioID) {
            Source
        }
        executeGetRawProjectTypes(inJurisdiction: $inJurisdiction) {
            RawProjectTypeID
            RawProjectType
            ProjectType
        }
        executeGetLocationList(inJurisdiction: $inJurisdiction) {
            LocationID
            LocationName
            State
        }
    }
`;

export const GetPriorYearProject = gql`
    mutation ExecuteGetPriorYearProjectList(
        $inJurisdiction: String!,
        $inScenarioID: String
    ) {
        executeGetPriorYearProjectList(
            inJurisdiction: $inJurisdiction
        ) {
            Source
            ProjectID
            ProjectName
            State
            typeCast
            Investment
            MW
            KM
            M2
            ProjectStage
            DeliveryAgency
            ContractingModel
            StartDateConstruction
            EndDateConstruction
            project_location
            Latitude
            Longitude
            FundingMode
            sa4_code
            sa4_name
            CommonwealthFunding
            ProjectStatus
            PeriodStartYear
            PeriodEndYear
        }
        executeGetState(inJurisdiction: $inJurisdiction) {
            State
        }
        executeGetSourceList(inJurisdiction: $inJurisdiction, inScenarioID: $inScenarioID) {
            Source
        }
        executeGetRawProjectTypes(inJurisdiction: $inJurisdiction) {
            RawProjectTypeID
            RawProjectType
            ProjectType
        }
        executeGetLocationList(inJurisdiction: $inJurisdiction) {
            LocationID
            LocationName
            State
        }
    }
`;

export const RunModel = gql`
    mutation ExecuteRunScenario(
        $inScenarioID: UUID!
    ) {
        executeRunScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;

export const getAllLists = gql`
    mutation ExecuteGetALLList($inJurisdiction: String!, $inScenarioID: String) {
        executeGetState(inJurisdiction: $inJurisdiction) {
            State
        }
        executeGetSourceList(inJurisdiction: $inJurisdiction, inScenarioID: $inScenarioID) {
            Source
        }
        executeGetPLEMTypesList(inJurisdiction: $inJurisdiction) {
            PLEMGroup
            PLEMGroupID
        }
        executeGetSuperSectorsList(inJurisdiction: $inJurisdiction) {
            SuperSectorID
            SuperSector
        }
        executeGetMasterTypesList(inJurisdiction: $inJurisdiction) {
            MasterTypeID
            MasterType
        }
        executeGetInfraFlagsList(inJurisdiction: $inJurisdiction) {
            InfraFlag
        }
        executeGetRawProjectTypes(inJurisdiction: $inJurisdiction) {
            RawProjectTypeID
            RawProjectType
            ProjectType
        }
        executeGetProjectTypesList(inJurisdiction: $inJurisdiction) {
            ProjectTypeID
            ProjectType
        }
        executeGetResourceGroupsList(inJurisdiction: $inJurisdiction) {
            ResourceGroupID
            ResourceGroup
        }
        executeGetLocationList(inJurisdiction: $inJurisdiction) {
            LocationID
            LocationName
            State
        }
        executeGetL1GroupList(inJurisdiction: $inJurisdiction) {
            Lvl1GroupID
            Lvl1Group
        }
        executeGetL2GroupList(inJurisdiction: $inJurisdiction) {
            Lvl1GroupID
            Lvl2GroupID
            Lvl2Group
        }
        executeGetPriorYearProjectList(
          inJurisdiction: $inJurisdiction
        ) {
            Source
            ProjectID
            ProjectName
            State
            typeCast
            Investment
            MW
            KM
            M2
            ProjectStage
            DeliveryAgency
            ContractingModel
            StartDateConstruction
            EndDateConstruction
            project_location
            Latitude
            Longitude
            FundingMode
            sa4_code
            sa4_name
            CommonwealthFunding
            ProjectStatus
            PeriodStartYear
            PeriodEndYear
        }
    }
`;

export const CreateStateProjectUploadBatch = gql`
    mutation ExecuteCreateProjectUploadBatch(
        $inUserSID: UUID!
    ) {
        executeCreateProjectUploadBatch(
            inUserSID: $inUserSID
        ) {
            BatchID
            LastUploadedBy
            LastUploadedDate
            ProjectsUploaded
        }
    }
`;


export const GetProjectBatchUpload = gql`
    mutation ExecuteGetProjectBatchUpload(
        $inUserSID: UUID!
    ) {
        executeGetProjectBatchUpload(
            inUserSID: $inUserSID
        ) {
            BatchID
            LastUploadedBy
            LastUploadedDate
            ProjectsUploaded
        }
    }
`;

export const AppendStateProjectBatchUpload = gql`
    mutation ExecuteAppendProjectBatchUpload(
       $inProjectBatchID: UUID!
       $inProjectJSON: String!
    ) {
        executeAppendProjectBatchUpload(
          inProjectBatchID: $inProjectBatchID
          inProjectJSON: $inProjectJSON
        ) {
            result
        }
    }
`;

export const CloseStateProjectUploadBatch = gql`
    mutation ExecuteCloseProjectUploadBatch(
        $inProjectBatchID: UUID!
    ) {
        executeCloseProjectUploadBatch(
            inProjectBatchID: $inProjectBatchID
        ) {
            result
        }
    }
`;
